import { render, staticRenderFns } from "./Communities.vue?vue&type=template&id=36078f3f&scoped=true"
import script from "./Communities.vue?vue&type=script&lang=js"
export * from "./Communities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36078f3f",
  null
  
)

export default component.exports